import { createTheme  } from '@material-ui/core/styles';
import palette from './palette';
import overrides from './overrides';
import dimensions from './dimensions';

export const createAppTheme = (mode) => createTheme ({
  palette: {
    ...palette,
    typeBackground: mode
  },
  overrides,
  dimensions
});

